import createIcon from '../../createIcon';

/**
 * @component @name Carpenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMDE4NCAxNC41MzY2TDcuMjg4NDQgMS44MDY2NEwzLjM5ODQ0IDUuNjk2NjRMMTEuNTI4NCAxNy4zNjY2QzEwLjc0ODQgMTguMTQ2NiAxMC43NDg0IDE5LjQxNjYgMTEuNTI4NCAyMC4xOTY2TDEyLjkzODQgMjEuNjA2NkMxMy43MTg0IDIyLjM4NjYgMTQuOTg4NCAyMi4zODY2IDE1Ljc2ODQgMjEuNjA2NkwyMC4wMDg0IDE3LjM2NjZDMjAuNzk4NCAxNi41ODY2IDIwLjc5ODQgMTUuMzE2NiAyMC4wMTg0IDE0LjUzNjZaTTE0LjM1ODQgMjAuMTg2NkwxMi45NDg0IDE4Ljc3NjZMMTcuMTg4NCAxNC41MzY2TDE4LjU5ODQgMTUuOTQ2NkwxNC4zNTg0IDIwLjE4NjZaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Carpenter = createIcon('Carpenter', [
  [
    'path',
    {
      d: 'M20.0184 14.5366L7.28844 1.80664L3.39844 5.69664L11.5284 17.3666C10.7484 18.1466 10.7484 19.4166 11.5284 20.1966L12.9384 21.6066C13.7184 22.3866 14.9884 22.3866 15.7684 21.6066L20.0084 17.3666C20.7984 16.5866 20.7984 15.3166 20.0184 14.5366ZM14.3584 20.1866L12.9484 18.7766L17.1884 14.5366L18.5984 15.9466L14.3584 20.1866Z',
      key: '1jwpgz',
    },
  ],
]);

export default Carpenter;
